<form [formGroup]="form" (ngSubmit)="onSubmitForm()">
  <div class="pt-2">
    <div class="form-check mt-3">
      <input
        class="form-check-input"
        type="checkbox"
        id="enableUserGroupManagement"
        formControlName="enableUserGroupManagement" />

      <div>
        <label class="form-check-label d-block" for="enableUserGroupManagement">
          {{ 'Settings::EnableUserGroupManagement' | abpLocalization }}
        </label>

        <small class="text-muted">
          {{ 'Settings::EnableUserGroupManagementDescription' | abpLocalization }}
        </small>
      </div>
    </div>

    <div class="btn-group mt-4">
      <button type="submit" class="btn btn-primary">
        <i class="me-1 fas fa-save"></i>
        <span>
          {{ 'AbpUi::Save' | abpLocalization }}
        </span>
      </button>
    </div>
  </div>
</form>
